/* Products, Add a product, a product's settings and Page layout (stage 5): AdminProducts.dc.html,
   AdminAddProduct.dc.html and AdminLayout.dc.html, in the admin shell's master brand. Every colour is
   a token (styles/tokens.css): the shell's for the page, each look's own for its covers, tiles and the
   layout preview. An own look's colours are the product's data, set inline. Small text never uses a
   grey lighter than --shell-ink-60 (the boards' 0.55 labels are 0.6 here), and a draft fades only its
   cover, so its words keep 4.5 to 1. Under 760px every grid is 1 column (Adam, 4 Oct, answer 5). */

.ap-page { display: flex; flex-direction: column; gap: 22px; min-width: 0; }
.ap-mark { width: 14px; height: 14px; fill: none; stroke: currentColor; stroke-width: 2.25; stroke-linecap: round; stroke-linejoin: round; flex-shrink: 0; }
.ap-mark--bold { stroke-width: 2.5; }
.ap-mark--heavy { stroke-width: 3; }
.ap-file { position: absolute; width: 1px; height: 1px; opacity: 0; pointer-events: none; overflow: hidden; }
.ap-eyebrow-crumbs { display: inline-flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.ap-eyebrow-crumbs a { color: var(--shell-ink-60); }
.ap-h3 { margin: 6px 0 0; font-size: 16px; font-weight: 800; }
.ap-num {
  width: 22px; height: 22px; border-radius: 11px; background: var(--shell-ink-06); font-size: 12px; font-weight: 800;
  display: inline-flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.ap-label, .ap-flabel { font-size: 13px; font-weight: 800; color: var(--shell-ink); }
.ap-label { font-size: 12px; letter-spacing: 0.06em; text-transform: uppercase; color: var(--shell-ink-60); }
.ap-icon-btn {
  width: 28px; height: 28px; border-radius: 7px; border: none; background: transparent; color: var(--shell-ink);
  display: inline-flex; align-items: center; justify-content: center; flex-shrink: 0; padding: 0;
}
.ap-icon-btn:hover:not(:disabled) { background: var(--shell-ink-04); }
.ap-icon-btn:disabled { opacity: 0.25; cursor: default; }
.ap-text-btn {
  height: 28px; padding: 0 10px; border-radius: 7px; border: none; background: transparent; color: var(--shell-ink-66);
  font-weight: 700; font-size: 12px; flex-shrink: 0;
}
.ap-text-btn:hover:not(:disabled) { color: var(--shell-ink); }
.ap-underline { height: 30px; color: var(--shell-ink); font-size: 13px; text-decoration: underline; }
.ap-saved { margin: 0; font-size: 13px; font-weight: 700; }
.ap-save-row { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; }
.ap-readonly {
  min-height: 44px; padding: 10px 12px; border-radius: 9px; border: 1px solid var(--shell-ink-10); background: var(--shell-ink-03);
  font-size: 15px; font-weight: 500; display: flex; align-items: center; overflow-wrap: anywhere;
}
.ap-step-line { margin: 0; font-size: 13px; line-height: 1.55; color: var(--shell-ink-66); }
.ap-pressed { border-color: var(--shell-ink) !important; background: var(--shell-ink-06) !important; }
.ad-btn.ap-btn-36 { height: 36px; padding: 0 14px; border-radius: 8px; font-size: 13px; }
.ad-btn.ap-btn-40 { height: 40px; padding: 0 14px; }

/* ---- Products -------------------------------------------------------------------------------- */
.ap-sechead { display: flex; align-items: baseline; justify-content: space-between; gap: 6px 20px; margin-bottom: -8px; flex-wrap: wrap; }
.ap-sechead-h { margin: 0; font-size: 18px; font-weight: 800; }
.ap-sechead-aside { font-size: 13px; color: var(--shell-ink-60); }
.ap-list + .ap-sechead { margin-top: 8px; }
.ap-list { display: flex; flex-direction: column; gap: 12px; }
.ad-empty.ap-list-empty { border: 1px solid var(--shell-ink-10); border-radius: 14px; }

.ap-prod { border-radius: 14px; border: 1px solid var(--shell-ink-10); overflow: hidden; background: var(--shell-bg); }
.ap-prod-row {
  display: grid; grid-template-columns: 150px minmax(0, 1fr) auto; gap: 20px; align-items: center; padding: 14px;
}
.ap-prod-row:hover { background: var(--shell-ink-02); }
.ap-prod-row--draft .ap-cover { opacity: 0.72; }
.ap-prod-main { display: flex; flex-direction: column; gap: 6px; min-width: 0; }
.ap-prod-title { display: flex; align-items: center; gap: 6px 10px; flex-wrap: wrap; }
.ap-prod-name { margin: 0; font-size: 16px; font-weight: 800; line-height: 1.3; }
.ap-prod-now { font-size: 14px; line-height: 1.45; color: var(--shell-ink-72); }
.ap-prod-what { line-height: 1.5; }
.ap-prod-prices { font-size: 13px; line-height: 1.45; color: var(--shell-ink-60); }
.ap-prod-buttons { display: flex; gap: 8px; margin-top: 2px; flex-wrap: wrap; }
.ap-prod-side { display: flex; align-items: center; gap: 10px; flex-shrink: 0; flex-wrap: wrap; justify-content: flex-end; }

.ap-chip {
  height: 22px; padding: 0 8px; border-radius: 6px; font-size: 11px; font-weight: 800; letter-spacing: 0.06em;
  text-transform: uppercase; display: inline-flex; align-items: center; white-space: nowrap; border: 1px solid transparent;
}
.ap-chip--type { background: var(--shell-ink-06); }
.ap-chip--live { background: var(--shell-ink); color: var(--shell-on-ink); border-color: var(--shell-ink); }
.ap-chip--draft, .ap-chip--free { background: var(--shell-bg); border-color: var(--shell-ink-20); }

.ap-cover {
  border-radius: 10px; border: 1px solid transparent; display: flex; flex-direction: column; justify-content: flex-end;
  overflow: hidden; overflow-wrap: anywhere; flex-shrink: 0;
}
.ap-cover--paid { width: 150px; height: 88px; padding: 12px; font-size: 15px; line-height: 1.1; }
.ap-cover--free { width: 150px; height: 72px; padding: 10px 12px; font-size: 14px; line-height: 1.15; font-weight: 800; }
.ap-cover--photo { padding: 0; }
.ap-cover--photo img { width: 100%; height: 100%; object-fit: cover; display: block; }
.ap-cover--master { background: var(--shell-bg); color: var(--shell-ink); border-color: var(--shell-ink-14); font-weight: 800; }
.ap-cover--acc { background: var(--acc-bg); color: var(--acc-green); border-color: var(--acc-rule); font-family: var(--acc-heading-font); font-weight: 700; }
.ap-cover--free.ap-cover--acc { font-family: inherit; font-weight: 800; }
.ap-cover--fe { background: var(--fe-bg); color: var(--fe-text); font-family: var(--fe-heading-font); font-weight: 400; letter-spacing: 0.02em; }
.ap-cover--navy { background: var(--poyt-navy); color: var(--on-dark); font-family: var(--poyt-heading-font); font-weight: 800; }
.ap-cover--orange { background: var(--poyt-orange); color: var(--on-dark); font-family: var(--poyt-heading-font); font-weight: 800; }
.ap-cover--green { background: var(--acc-green); color: var(--on-dark); font-family: var(--acc-heading-font); font-weight: 700; }
.ap-cover--free.ap-cover--green { font-family: inherit; font-weight: 800; }
.ap-cover--ink { background: var(--shell-ink); color: var(--on-dark); }
.ap-cover--light { background: var(--shell-tile-light); color: var(--shell-ink); border-color: var(--shell-ink-10); }

.ad-switch.ap-switch { width: 46px; height: 26px; border-radius: 13px; }
.ap-switch .ad-switch-knob { width: 20px; height: 20px; border-radius: 10px; }
.ad-switch.ap-switch[aria-checked="true"] .ad-switch-knob { left: 23px; }

.ap-confirm-wrap { padding: 0 14px 14px; }

.ap-panel {
  padding: 16px 18px 18px; border-top: 1px solid var(--shell-ink-08); background: var(--shell-ink-02);
  display: flex; flex-direction: column; gap: 10px;
}
.ap-panel-line { margin: 0; font-size: 13px; line-height: 1.55; color: var(--shell-ink-66); }
.ap-panel-quiet { margin: 0; font-size: 13px; line-height: 1.5; color: var(--shell-ink-60); }
.ap-steps { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 10px; }
.ap-step {
  display: flex; align-items: center; gap: 10px; padding: 8px 10px; border-radius: 8px;
  background: var(--shell-bg); border: 1px solid var(--shell-ink-10);
}
.ap-step-text { flex-grow: 1; min-width: 0; font-size: 14px; line-height: 1.45; display: flex; flex-direction: column; gap: 2px; overflow-wrap: anywhere; }
.ap-step-note { font-size: 12px; color: var(--shell-ink-60); }
.ap-add-step { display: flex; gap: 8px; }
.ap-add-step .ad-btn { height: 36px; }
.ad-input.ap-add-input { height: 36px; flex-grow: 1; font-size: 13px; border-radius: 8px; }
.ap-cert-give { font-weight: 700; }
.ap-cert-body { display: flex; flex-direction: column; gap: 6px; }
.ap-rules { display: flex; gap: 6px; flex-wrap: wrap; }
.ap-rule {
  min-height: 32px; padding: 6px 11px; border-radius: 8px; border: 1.5px solid var(--shell-ink-14); background: var(--shell-bg);
  color: var(--shell-ink); font-size: 12px; font-weight: 700; line-height: 1.3; text-align: left;
}
.ap-rule[aria-pressed="true"] { border-color: var(--shell-ink); background: var(--shell-ink-06); }
.ap-rule:disabled { opacity: 0.45; cursor: default; }

.ap-panels { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 22px; align-items: start; }
.ad-card.ap-info { padding: 20px 22px; display: flex; flex-direction: column; gap: 12px; }
.ap-info-h { margin: 0; font-size: 17px; font-weight: 800; }
.ap-info-line { margin: 0; font-size: 13px; line-height: 1.5; color: var(--shell-ink-60); }
.ap-rules-list { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 12px; }
.ap-rule-row { display: flex; gap: 12px; align-items: flex-start; }
.ap-rule-text { display: flex; flex-direction: column; gap: 2px; }
.ap-rule-head { font-size: 14px; font-weight: 700; }
.ap-rule-body { font-size: 13px; line-height: 1.55; color: var(--shell-ink-66); }
.ap-types { margin: 0; display: flex; flex-direction: column; gap: 10px; }
.ap-type { display: flex; flex-direction: column; gap: 1px; }
.ap-type dt { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.ap-type dd { margin: 0; font-size: 13px; line-height: 1.5; color: var(--shell-ink-62); }
.ap-type-name { font-size: 14px; font-weight: 700; }
.ap-type-access { font-size: 11px; font-weight: 800; letter-spacing: 0.06em; text-transform: uppercase; color: var(--shell-ink-60); }
.ap-moves { list-style: none; margin: 0; padding: 0; display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 8px; }
.ap-move {
  display: grid; grid-template-columns: minmax(0, 1fr) minmax(0, 1fr); gap: 14px; padding: 10px 12px; border-radius: 9px;
  background: var(--shell-ink-03); font-size: 13px; line-height: 1.45;
}
.ap-move-from { font-weight: 700; overflow-wrap: anywhere; }
.ap-move-to { color: var(--shell-ink-66); display: flex; flex-direction: column; gap: 4px; overflow-wrap: anywhere; min-width: 0; }
.ap-move-state { font-size: 12px; font-weight: 700; color: var(--shell-ink); }

.ap-see-list { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; border: 1px solid var(--shell-ink-10); border-radius: 12px; overflow: hidden; }
.ap-see-row { display: flex; align-items: center; gap: 12px; padding: 12px 14px; border-bottom: 1px solid var(--shell-ink-06); flex-wrap: wrap; }
.ap-see-row:last-child { border-bottom: none; }
.ap-see-who { display: flex; flex-direction: column; flex-grow: 1; min-width: 0; }
.ap-see-name { font-size: 15px; font-weight: 700; }
.ap-see-email { font-size: 13px; color: var(--shell-ink-60); overflow-wrap: anywhere; }
.ad-empty.ap-see-empty { padding: 0; }

/* ---- Add a product --------------------------------------------------------------------------- */
.ap-add { gap: 22px; }
.ap-stepper { display: grid; grid-template-columns: repeat(5, minmax(0, 1fr)); gap: 10px; }
.ap-stepper-step {
  display: flex; align-items: center; gap: 10px; padding: 12px 14px; border-radius: 10px; border: 1.5px solid var(--shell-ink-12);
  background: var(--shell-bg); color: var(--shell-ink); text-align: left; min-width: 0; opacity: 1;
}
.ap-stepper-step[data-state="now"] { border-color: var(--shell-ink); background: var(--shell-ink-04); }
.ap-stepper-step:disabled { cursor: default; color: var(--shell-ink); }
.ap-disc {
  width: 26px; height: 26px; border-radius: 13px; font-size: 13px; font-weight: 800; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center; background: var(--shell-ink-08); color: var(--shell-ink-60);
}
.ap-stepper-step[data-state="now"] .ap-disc, .ap-stepper-step[data-state="done"] .ap-disc { background: var(--shell-ink); color: var(--shell-on-ink); }
.ap-stepper-text { display: flex; flex-direction: column; min-width: 0; }
.ap-stepper-name { font-size: 14px; font-weight: 800; }
.ap-stepper-sub { font-size: 12px; color: var(--shell-ink-60); }
.ap-stepper-now { display: none; margin: -10px 0 0; font-size: 14px; font-weight: 800; }

.ap-add-grid { display: grid; grid-template-columns: minmax(0, 1fr) 340px; gap: 24px; align-items: start; }
.ap-add-form {
  border-radius: 14px; border: 1px solid var(--shell-ink-10); padding: 26px 28px; display: flex; flex-direction: column;
  gap: 20px; min-height: 620px; min-width: 0;
}
.ad-app .ap-add-form[tabindex]:focus, .ad-app .ap-add-form[tabindex]:focus-visible, .ad-app .ap-done[tabindex]:focus-visible { outline: none; }
.ap-add .ad-label--plain { font-size: 13px; font-weight: 800; }
.ap-step-head { display: flex; flex-direction: column; gap: 6px; }
.ap-step-h { margin: 0; font-size: 21px; font-weight: 800; }
.ap-step-sub { margin: 0; font-size: 14px; line-height: 1.5; color: var(--shell-ink-60); }

.ap-types-grid, .ap-looks, .ap-two { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; }
.ap-looks, .ap-two { gap: 10px; }
.ap-opt {
  display: flex; flex-direction: column; gap: 6px; padding: 16px 18px; border-radius: 12px; border: 1.5px solid var(--shell-ink-12);
  background: var(--shell-bg); color: var(--shell-ink); text-align: left; min-width: 0;
}
.ap-opt:hover { border-color: var(--shell-ink-30); }
.ap-opt[aria-checked="true"] { border-color: var(--shell-ink); background: var(--shell-ink-03); }
.ap-opt--greyed { opacity: 0.55; cursor: default; }
.ap-opt--greyed:hover { border-color: var(--shell-ink-12); }
.ap-two .ap-opt { padding: 14px 16px; border-radius: 10px; gap: 4px; }
.ap-opt-name { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; font-size: 16px; font-weight: 800; }
.ap-two .ap-opt-name { font-size: 15px; }
.ap-opt-what { font-size: 13px; line-height: 1.55; color: var(--shell-ink-66); }
.ap-opt-foot { display: flex; justify-content: space-between; gap: 10px; font-size: 12px; color: var(--shell-ink-60); }
.ap-opt-access { font-weight: 800; letter-spacing: 0.06em; text-transform: uppercase; white-space: nowrap; }
/* the 7 types' radios sit in the grid's cells, Webinar's link in the last 1, outside the radiogroup */
.ap-types-radios { display: contents; }
a.ap-type-link { color: var(--shell-ink); text-decoration: none; }
.ap-type-go { font-size: 13px; font-weight: 700; text-decoration: underline; text-underline-offset: 3px; }
a.ap-type-link:hover .ap-type-go { text-decoration-thickness: 2px; }
.ap-look { flex-direction: row; align-items: center; gap: 12px; padding: 12px 14px; border-radius: 10px; }
.ap-swatches { display: flex; flex-shrink: 0; }
.ap-swatch { width: 22px; height: 22px; border-radius: 11px; box-shadow: 0 0 0 1px var(--shell-ink-14); }
.ap-swatch--2 { margin-left: -6px; }
.ap-opt-text { display: flex; flex-direction: column; }
.ap-look .ap-opt-name { font-size: 14px; }
.ap-opt-note { font-size: 12px; color: var(--shell-ink-60); }
.ap-own-colours { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 12px; }
.ap-fonts { display: flex; gap: 6px; flex-wrap: wrap; }
.ap-font {
  height: 36px; padding: 0 12px; border-radius: 8px; border: 1.5px solid var(--shell-ink-14); background: var(--shell-bg);
  color: var(--shell-ink); font-size: 15px;
}
.ap-font[aria-checked="true"] { border-color: var(--shell-ink); }
.ap-contrast {
  display: flex; flex-direction: column; gap: 6px; padding: 12px 14px; border-radius: 10px;
  background: var(--shell-ink-03); border: 1px solid var(--shell-ink-08);
}
.ap-contrast-h { font-size: 13px; font-weight: 800; }
.ap-contrast-row { display: flex; justify-content: space-between; gap: 12px; font-size: 13px; }
.ap-contrast-what { color: var(--shell-ink-72); }
.ap-contrast-result { font-weight: 800; white-space: nowrap; }
.ap-contrast-note { font-size: 12px; line-height: 1.5; color: var(--shell-ink-60); }
.ap-cover-row { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; }
.ap-cover-words { display: flex; flex-direction: column; align-items: flex-start; gap: 8px; min-width: 0; }

.ap-sub { display: flex; flex-direction: column; gap: 8px; }
.ap-sub--tight { margin-top: 4px; }
.ad-check.ap-tick {
  padding: 10px 12px; border-radius: 9px; border: 1px solid var(--shell-ink-10); align-items: center;
}
/* what comes with every product of the type (Add a product's Content step), listed, not ticked */
.ap-pieces { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 8px; }
.ap-piece { display: flex; align-items: center; gap: 10px; font-size: 14px; line-height: 1.45; color: var(--shell-ink); }
.ap-piece .ap-mark { color: var(--shell-ink-60); }
.ap-join-opts .ad-option, .ap-runs .ad-option { font-weight: 600; }
.ap-join-opts .ad-option { flex-direction: column; align-items: flex-start; gap: 2px; }
.ap-join-opts .ad-option-note { text-align: left; }
.ap-schedule { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 12px; }
.ap-schedule--modules { grid-template-columns: minmax(0, 160px); }

.ap-tile-col { display: flex; flex-direction: column; gap: 14px; }
.ap-tile-h { font-size: 12px; font-weight: 800; letter-spacing: 0.1em; text-transform: uppercase; color: var(--shell-ink-60); }
.ap-tile-frame { border-radius: 16px; background: var(--shell-bg); border: 1px solid var(--shell-ink-10); padding: 16px; }
.ap-tile { border-radius: 14px; overflow: hidden; border: 1px solid var(--shell-ink-10); }
.ap-tile-art {
  height: 150px; border-bottom: 1px solid var(--shell-ink-08); padding: 18px; display: flex; flex-direction: column;
  justify-content: space-between; overflow: hidden;
}
.ap-tile-rule { width: 30px; height: 4px; }
.ap-tile-name { font-size: 24px; line-height: 1.08; overflow-wrap: anywhere; }
.ap-tile-foot { padding: 14px 16px 16px; display: flex; flex-direction: column; gap: 5px; background: var(--shell-ink-02); color: var(--shell-ink); }
.ap-tile-kind { font-size: 10px; font-weight: 800; letter-spacing: 0.14em; text-transform: uppercase; color: var(--shell-ink-60); }
.ap-tile-title { font-size: 15px; font-weight: 700; overflow-wrap: anywhere; }
.ap-tile-line { font-size: 13px; color: var(--shell-ink-66); }
.ap-tile-note { margin: 0; font-size: 13px; line-height: 1.55; color: var(--shell-ink-60); }

.ap-add-foot { display: flex; justify-content: space-between; align-items: center; gap: 12px; }
.ap-add-foot .ad-btn { height: 44px; padding: 0 22px; }
.ap-add-foot .ap-back { padding: 0 18px; }

.ap-done {
  max-width: 720px; padding: 32px; border-radius: 16px; border: 1px solid var(--shell-ink-10); display: flex; flex-direction: column; gap: 14px;
}
.ap-done-mark {
  width: 44px; height: 44px; border-radius: 22px; background: var(--shell-ink); color: var(--shell-on-ink);
  display: flex; align-items: center; justify-content: center;
}
.ap-done-mark .ap-mark { width: 22px; height: 22px; }
.ap-done-h { margin: 0; font-size: 24px; font-weight: 800; overflow-wrap: anywhere; }
.ap-done-line { margin: 0; font-size: 15px; line-height: 1.6; color: var(--shell-ink-70); }
.ap-done-actions { display: flex; gap: 10px; margin-top: 6px; flex-wrap: wrap; }

/* ---- A product's settings -------------------------------------------------------------------- */
.ap-settings .ad-card { max-width: 920px; }
.ap-settings .ad-label--plain { font-size: 13px; font-weight: 800; }
.ap-facts { margin: 0; display: flex; flex-direction: column; gap: 10px; }
.ap-fact { display: grid; grid-template-columns: 220px minmax(0, 1fr); gap: 4px 16px; font-size: 14px; line-height: 1.5; }
.ap-fact dt { font-weight: 700; }
.ap-fact dd { margin: 0; color: var(--shell-ink-72); overflow-wrap: anywhere; }
.ad-input.ap-prefix { max-width: 160px; text-transform: uppercase; }
.ap-offer .ad-switch-row .ad-switch-label { font-size: 14px; color: var(--shell-ink); }

/* ---- Page layout ----------------------------------------------------------------------------- */
.ap-layout-actions { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
.ap-status { font-size: 13px; font-weight: 700; color: var(--shell-ink-60); }
.ap-layout-bar {
  display: flex; align-items: flex-end; justify-content: space-between; gap: 12px 20px; border-bottom: 1px solid var(--shell-ink-10); flex-wrap: wrap;
}
.ap-layout-tabs { display: flex; gap: 28px; }
.ap-layout-tabs .ad-tab { border-bottom-width: 3px; font-weight: 700; color: var(--shell-ink-60); }
.ap-layout-tabs .ad-tab[aria-selected="true"] { color: var(--shell-ink); border-bottom-color: var(--shell-ink); }
.ap-devices { display: flex; gap: 4px; padding: 4px; margin-bottom: 8px; border-radius: 10px; background: var(--shell-ink-05); }
.ap-device {
  height: 32px; padding: 0 14px; border-radius: 7px; border: none; background: transparent; color: var(--shell-ink); font-weight: 700; font-size: 13px;
}
.ap-device[aria-pressed="true"] { background: var(--shell-bg); box-shadow: 0 1px 3px var(--shell-ink-16); }
.ap-layout .ad-note { padding: 16px 20px; border-radius: 12px; font-size: 14px; line-height: 1.6; align-items: flex-start; }
.ap-layout-grid { display: grid; grid-template-columns: 440px minmax(0, 1fr); gap: 24px; align-items: start; }
.ap-layout-left { display: flex; flex-direction: column; gap: 18px; min-width: 0; }
.ap-sections { border-radius: 14px; border: 1px solid var(--shell-ink-10); overflow: hidden; }
.ap-sections-head {
  padding: 16px 18px; display: flex; align-items: center; justify-content: space-between; gap: 10px;
  border-bottom: 1px solid var(--shell-ink-08); flex-wrap: wrap;
}
.ap-sections-h { margin: 0; font-size: 16px; font-weight: 800; }
.ap-sec-list { list-style: none; margin: 0; padding: 0; }
.ap-sec {
  display: flex; align-items: center; gap: 8px; padding: 10px 12px 10px 14px; border-bottom: 1px solid var(--shell-ink-07);
}
.ap-sec-text { flex-grow: 1; min-width: 0; display: flex; flex-direction: column; gap: 2px; padding: 2px 0; }
.ap-sec-name { font-size: 14px; font-weight: 700; }
.ap-sec-what { font-size: 12px; line-height: 1.4; color: var(--shell-ink-60); }
.ap-sec--hidden .ap-sec-name { color: var(--shell-ink-60); text-decoration: line-through; }
.ap-always {
  width: 42px; flex-shrink: 0; font-size: 11px; font-weight: 800; letter-spacing: 0.04em; text-transform: uppercase;
  color: var(--shell-ink-60); text-align: center;
}
.ap-sections-foot { margin: 0; padding: 12px 18px 14px; font-size: 13px; line-height: 1.5; color: var(--shell-ink-60); }
.ad-card.ap-look-panel { padding: 16px 18px; display: flex; flex-direction: column; gap: 8px; }
.ap-look-h { margin: 0; font-size: 15px; font-weight: 800; }
.ap-look-line { margin: 0; font-size: 13px; line-height: 1.55; color: var(--shell-ink-70); }
.ap-look-sw { display: flex; gap: 6px; margin-top: 2px; align-items: center; flex-wrap: wrap; }
.ap-look-chip { width: 30px; height: 30px; border-radius: 7px; border: 1px solid var(--shell-ink-14); }
.ap-look-sw--fe .ap-look-chip--page { background: var(--fe-bg); }
.ap-look-sw--fe .ap-look-chip--card { background: var(--fe-surface); }
.ap-look-sw--fe .ap-look-chip--accent { background: var(--fe-green); }
.ap-look-sw--fe .ap-look-chip--text { background: var(--fe-text); }
.ap-look-sw--acc .ap-look-chip--page { background: var(--acc-bg); }
.ap-look-sw--acc .ap-look-chip--card { background: var(--acc-card); }
.ap-look-sw--acc .ap-look-chip--accent { background: var(--acc-green); }
.ap-look-sw--acc .ap-look-chip--text { background: var(--acc-ink); }
.ap-look-sw--master .ap-look-chip--page { background: var(--shell-bg); }
.ap-look-sw--master .ap-look-chip--card { background: var(--shell-tile-light); }
.ap-look-sw--master .ap-look-chip--accent { background: var(--shell-gold); }
.ap-look-sw--master .ap-look-chip--text { background: var(--shell-ink); }
.ap-look-sw--master .ap-look-font { font-weight: 800; font-size: 18px; }
.ap-look-sw--poyt .ap-look-chip--page { background: var(--poyt-paper); }
.ap-look-sw--poyt .ap-look-chip--card { background: var(--shell-bg); }
.ap-look-sw--poyt .ap-look-chip--accent { background: var(--poyt-orange); }
.ap-look-sw--poyt .ap-look-chip--text { background: var(--poyt-ink); }
.ap-look-sw--poyt .ap-look-font { font-family: var(--poyt-heading-font); font-weight: 800; font-size: 18px; }
.ap-look-sw--poyt .ap-look-body { font-family: var(--poyt-body-font); }
.ap-look-font { margin-left: 6px; font-size: 20px; line-height: 30px; }
.ap-look-sw--fe .ap-look-font { font-family: var(--fe-heading-font); }
.ap-look-sw--acc .ap-look-font { font-family: var(--acc-heading-font); font-weight: 700; font-size: 18px; }
.ap-look-body { font-size: 15px; font-weight: 600; line-height: 30px; }
.ap-look-sw--fe .ap-look-body { font-family: var(--fe-body-font); }
.ap-look-sw--acc .ap-look-body { font-family: var(--acc-body-font); }

/* the drawn preview, in the product's look */
.ap-pv-col { display: flex; flex-direction: column; gap: 12px; position: sticky; top: 16px; min-width: 0; }
.ap-pv-head { display: flex; align-items: center; justify-content: space-between; gap: 6px 12px; flex-wrap: wrap; }
.ap-pv-title { font-size: 12px; font-weight: 800; letter-spacing: 0.08em; text-transform: uppercase; color: var(--shell-ink-60); }
.ap-pv-note { font-size: 12px; color: var(--shell-ink-60); }
.ap-pv { align-self: center; width: 100%; border-radius: 12px; border: 1px solid var(--shell-ink-14); overflow: hidden; }
.ap-pv--phone { width: 300px; max-width: 100%; border-radius: 26px; border: 6px solid var(--shell-ink); }
.ap-pv--fe { background: var(--fe-bg); color: var(--fe-text); font-family: var(--fe-body-font); --pv-muted: var(--fe-muted); --pv-rule: var(--on-dark-12); --pv-accent: var(--fe-green); }
.ap-pv--acc { background: var(--acc-bg); color: var(--acc-ink); font-family: var(--acc-body-font); --pv-muted: var(--acc-soft); --pv-rule: var(--acc-rule); --pv-accent: var(--acc-green); }
.ap-pv--master { background: var(--shell-bg); color: var(--shell-ink); font-family: var(--shell-font); --pv-muted: var(--shell-ink-62); --pv-rule: var(--shell-ink-10); --pv-accent: var(--shell-ink); }
.ap-pv--poyt { background: var(--poyt-paper); color: var(--poyt-ink); font-family: var(--poyt-body-font); --pv-muted: var(--poyt-soft); --pv-rule: var(--poyt-rule); --pv-accent: var(--poyt-orange); }
.ap-pv-bar { height: 44px; display: flex; align-items: center; justify-content: space-between; padding: 0 16px; border-bottom: 1px solid var(--pv-rule); gap: 8px; }
.ap-pv-brand { display: flex; align-items: center; gap: 10px; min-width: 0; }
.ap-pv-lib { font-size: 11px; color: var(--pv-muted); }
.ap-pv-name { font-size: 15px; letter-spacing: 0.02em; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.ap-pv--fe .ap-pv-name { font-family: var(--fe-heading-font); }
.ap-pv--acc .ap-pv-name { font-family: var(--acc-heading-font); font-weight: 700; letter-spacing: 0; }
.ap-pv-ring { width: 24px; height: 24px; border-radius: 12px; border: 1.5px solid var(--pv-accent); flex-shrink: 0; }
.ap-pv-nav { display: flex; gap: 16px; padding: 0 16px; border-bottom: 1px solid var(--pv-rule); }
.ap-pv-tab { padding: 9px 0 7px; border-bottom: 2px solid transparent; font-size: 11px; font-weight: 700; color: var(--pv-muted); }
.ap-pv-tab--on { border-bottom-color: var(--pv-accent); color: inherit; }
.ap-pv-body { padding: 16px 0 20px; display: flex; flex-direction: column; gap: 12px; }
.ap-pv-sec { margin: 0 14px; padding: 14px; border-radius: 10px; border: 1px solid transparent; display: flex; flex-direction: column; gap: 8px; }
.ap-pv--fe .ap-pv-sec--card { background: var(--fe-surface); border-color: var(--on-dark-12); }
.ap-pv--acc .ap-pv-sec--card { background: var(--acc-card); border-color: var(--acc-rule); }
.ap-pv--master .ap-pv-sec--card { background: var(--shell-bg); border-color: var(--shell-ink-10); }
.ap-pv--poyt .ap-pv-sec--card { background: var(--shell-bg); border-color: var(--poyt-rule); }
.ap-pv--poyt .ap-pv-h, .ap-pv--poyt .ap-pv-big, .ap-pv--poyt .ap-pv-name { font-family: var(--poyt-heading-font); font-weight: 800; }
.ap-pv--poyt .ap-pv-tile { background: var(--poyt-navy-07); border: 1px solid var(--poyt-rule); }
.ap-pv--poyt .ap-pv-btn { background: var(--poyt-navy); color: var(--on-dark); }
.ap-pv--master .ap-pv-h, .ap-pv--master .ap-pv-big, .ap-pv--master .ap-pv-name { font-weight: 800; }
.ap-pv--master .ap-pv-tile { background: var(--shell-ink-03); border: 1px solid var(--shell-ink-10); }
.ap-pv--master .ap-pv-btn { background: var(--shell-ink); color: var(--shell-on-ink); }
.ap-pv-h { font-size: 13px; letter-spacing: 0.03em; }
.ap-pv--fe .ap-pv-h, .ap-pv--fe .ap-pv-big { font-family: var(--fe-heading-font); }
.ap-pv--acc .ap-pv-h, .ap-pv--acc .ap-pv-big { font-family: var(--acc-heading-font); font-weight: 700; }
.ap-pv-big { font-size: 28px; line-height: 1; }
.ap-pv-big--phone { font-size: 22px; }
.ap-pv-line { font-size: 11px; line-height: 1.45; color: var(--pv-muted); font-weight: 500; }
.ap-pv-line--strong { color: inherit; font-weight: 700; }
.ap-pv-tiles { display: grid; gap: 8px; }
.ap-pv-tile { border-radius: 6px; padding: 8px; font-size: 10px; line-height: 1.35; font-weight: 600; }
.ap-pv--fe .ap-pv-tile { background: var(--on-dark-05); border: 1px solid var(--on-dark-10); }
.ap-pv--acc .ap-pv-tile { background: var(--acc-green-08); border: 1px solid var(--acc-rule); }
.ap-pv-btn { align-self: flex-start; height: 26px; padding: 0 12px; border-radius: 6px; font-size: 11px; font-weight: 700; display: flex; align-items: center; }
.ap-pv--fe .ap-pv-btn { background: var(--fe-green); color: var(--fe-on-green); }
.ap-pv--acc .ap-pv-btn { background: var(--acc-green); color: var(--on-dark); }
.ap-pv-empty { padding: 0 16px; font-size: 12px; line-height: 1.5; color: var(--pv-muted); }

/* ---- The widths between ---------------------------------------------------------------------- */
@media (max-width: 1279px) {
  .ap-moves { grid-template-columns: minmax(0, 1fr); }
  .ap-prod-row { grid-template-columns: 150px minmax(0, 1fr); }
  .ap-prod-side { grid-column: 2; justify-content: flex-start; }
  .ap-add-grid { grid-template-columns: minmax(0, 1fr) 300px; }
  .ap-stepper-sub { display: none; }
  .ap-schedule { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .ap-layout-grid { grid-template-columns: minmax(0, 1fr) minmax(0, 1fr); }
}
@media (max-width: 1023px) {
  .ap-panels { grid-template-columns: minmax(0, 1fr); }
  .ap-moves { grid-template-columns: minmax(0, 1fr); }
  .ap-add-grid { grid-template-columns: minmax(0, 1fr); }
  .ap-layout-grid { grid-template-columns: minmax(0, 1fr); }
  .ap-pv-col { position: static; }
}

/* ---- Phone ----------------------------------------------------------------------------------- */
@media (max-width: 760px) {
  .ap-page { gap: 18px; }
  /* at least 24px to tap (item 178) */
  .ap-eyebrow-crumbs a { display: inline-flex; align-items: center; min-height: 24px; }
  .ap-prod-row { grid-template-columns: minmax(0, 1fr); gap: 14px; }
  .ap-prod-side { grid-column: 1; }
  .ap-cover--paid, .ap-cover--free { width: 100%; }
  .ap-prod-side .ad-btn { flex: 1 1 auto; }
  .ap-panel { padding: 14px; }
  .ap-step { flex-wrap: wrap; }
  .ap-add-step { flex-direction: column; }
  .ap-move { grid-template-columns: minmax(0, 1fr); gap: 4px; }
  .ad-card.ap-info { padding: 18px 16px; }

  .ap-stepper { gap: 6px; }
  .ap-stepper-step { justify-content: center; padding: 10px 6px; }
  .ap-stepper-text { position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(0, 0, 0, 0); white-space: nowrap; }
  .ap-stepper-now { display: block; }
  .ap-add-form { padding: 20px 16px; min-height: 0; }
  .ap-types-grid, .ap-looks, .ap-two, .ap-own-colours, .ap-schedule { grid-template-columns: minmax(0, 1fr); }
  .ap-add-foot .ad-btn { flex: 1 1 0; padding: 0 12px; }
  .ap-done { padding: 22px 16px; }

  .ap-fact { grid-template-columns: minmax(0, 1fr); }

  .ap-layout-actions { width: 100%; }
  .ap-layout-actions .ad-btn { flex: 1 1 0; }
  .ap-status { flex-basis: 100%; }
  .ap-layout-tabs { gap: 20px; }
  .ap-sec { padding: 10px 10px 10px 12px; gap: 6px; }
}

/* a checklist step's {group} and {next_session}: what each member reads there */
.ap-step-ph { font-weight: 700; }
.ap-step-hint { margin: 0; font-size: 12px; line-height: 1.5; color: var(--shell-ink-60); }
